import { Skeleton, Stack, VisuallyHidden } from '@mantine/core';
import { useTranslate } from '@tolgee/react';

/** Squelette de `RpuUploadForm` affiché pendant le chargement des services d'urgence. */
const RpuUploadFormLoader = () => {
  const { t } = useTranslate();

  return (
    <Stack gap="md" role="status" aria-busy="true">
      <VisuallyHidden>{t('admin.ingestions.import.loading')}</VisuallyHidden>
      <Stack gap={6} aria-hidden="true">
        <Skeleton height={14} width="30%" />
        <Skeleton height={36} />
      </Stack>
      <Skeleton height={140} aria-hidden="true" />
      <Skeleton height={36} aria-hidden="true" />
    </Stack>
  );
};

export default RpuUploadFormLoader;
